import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly sessionStorageItemName = 'ds24_sessionId';

  constructor() {}

  getSessionId(): string {
    let sessionId = sessionStorage.getItem(this.sessionStorageItemName);
    if (!sessionId) {
      sessionId = this.generateSessionId();
      sessionStorage.setItem(this.sessionStorageItemName, sessionId);
    }
    return sessionId;
  }

  private generateSessionId(): string {
    const timestamp = Date.now();
    const randomPart = Math.random().toString(36).substring(2, 9);
    return `${timestamp}-${randomPart}`;
  }

  clearSession(): void {
    sessionStorage.removeItem(this.sessionStorageItemName);
  }
}
